// extracted by mini-css-extract-plugin
module.exports = {"title":"EditWorkout_title__3Hq3D"};